import React, { useState, useEffect } from "react";
import TableView from "./table/table-view";
import Button from "../../../components/buttons/button";
import CreateNewsModal from "./table/components/create-news-modal";
import { useGetNewsQuery } from "../../../store/Reducer/news";
import toast from "react-hot-toast";
import TablePaginationCustom from "../user-events/table/table-pagination-custom";
import { Header } from "../../../components/page-header/Header";
import { useTranslation } from "react-i18next";
import TableFilters from "./table/table-filters";

const UserNews = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");

  const {
    data: newsData,
    isLoading,
    error,
  } = useGetNewsQuery({ page: currentPage, search });

  const openModal = (edit = false, rowData = null) => {
    setIsEdit(edit);
    setSelectedRowData(rowData);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsEdit(false);
    setSelectedRowData(null);
    setIsOpen(false);
  };

  const TABLE_HEAD = [
    { id: "news", label: "News" },
    { id: "link", label: "Links" },
    { id: "status", label: "Status" },
    { id: "action", label: "" },
  ];

  if (error) {
    toast.error(error?.message);
  }

  const breadcrumbItems = [
    { label: t("universal_dashboard_text"), to: '/user-dashboard' },
    { label: t("news_breadcurmbs_title") },
  ];


  return (
    <>
      <section className="min-h-[86vh] bg-gradient-to-b from-slate-50 to-gray-50">
        <div className="max-w-7xl mx-auto p-6">
          <div className="">
            <div className="mb-5 header flex justify-between items-center flex-wrap">
              <div className="flex items-center justify-between">
                <Header title={t("news_title")} breadcrumbItems={breadcrumbItems} />
              </div>
              <Button
                text={t("universal_create_text")}
                type="button"
                className="px-6 text-nowrap"
                onClick={() => openModal(false)}
              />
            </div>

            <TableFilters search={search} setSearch={setsearch} />

            {isLoading ? (
              <div className="pt-16 flex justify-center mt-12 items-center">
                <div
                  className="animate-spin inline-block w-8 h-8 border-[3px] border-current border-t-transparent text-gray-700 dark:text-gray-100 rounded-full"
                  role="status"
                  aria-label="loading"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <TableView
                  newsData={newsData?.data || []}
                  TABLE_HEAD={TABLE_HEAD}
                  onEditRow={(rowData) => openModal(true, rowData)}
                  searching={Boolean(search)}
                />
                {/* Pagination */}
                <TablePaginationCustom
                  details={newsData?.pagination || []}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPages={newsData?.pagination?.totalPages}
                  totalItems={newsData?.pagination?.totalNews}
                />
              </>
            )}
          </div>
        </div>
      </section>

      <CreateNewsModal
        isOpen={isOpen}
        closeModal={closeModal}
        isEdit={isEdit}
        rowData={selectedRowData}
      />
    </>
  );
};

export default UserNews;
